import useIsDesktop from 'hooks/isDesktop';
import {useConfirmModal} from 'hooks/modal';
import {useModal} from 'mui-modal-provider';
import {useEffect} from 'react';

const OutHook = {};

export const OutHookConfigurator = () => {
  const _useModal = useModal();
  const _useConfirmModal = useConfirmModal();
  const _useIsDesktop = useIsDesktop();

  useEffect(() => {
    OutHook.useModal = _useModal;
  }, [_useModal]);

  useEffect(() => {
    OutHook.useConfirmModal = _useConfirmModal;
  }, [_useConfirmModal]);

  useEffect(() => {
    OutHook.useIsDesktop = _useIsDesktop;
  }, [_useIsDesktop]);

  return null;
};

export default OutHook;
